import Vue from 'vue';

export class DateHelper {
    
    constructor(){
        // empty
    }
    
    public formatDateWeekdayName(dateString): string {
        const locale = Vue.i18n.locale();
        return new Date(dateString).toLocaleDateString(
            locale, 
            {
                weekday: "long"
            }
        );
    }

    public formatDateWithShortWeekDay(dateString): string {
        const locale = Vue.i18n.locale();
        return new Date(dateString).toLocaleDateString(
            locale, 
            {
                weekday: "short",
                month: "numeric",
                day: "numeric",
                year: "numeric"
            }
        );
    }

    public formatDateTimeWithShortWeekDay(date: Date): string {
        const locale = Vue.i18n.locale();
        return date.toLocaleDateString(
            locale, 
            {
                weekday: "short",
                month: "numeric",
                day: "numeric",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            }
        );      
    }

    public formatDateWithLongWeekDay(dateString): string {
        const locale = Vue.i18n.locale();
        return new Date(dateString).toLocaleDateString(
            locale, 
            {
                weekday: "long",
                month: "numeric",
                day: "numeric",
                year: "numeric"
            }
        );
    }

    public formatDateShort(dateString): string {
        const locale = Vue.i18n.locale();
        return new Date(dateString).toLocaleDateString(
            locale, 
            {
                month: "numeric",
                day: "numeric",
                year: "numeric"
            }
        );
    }

    public datePickerTitleFormat(val, locale): string {
        const currentLocale = locale ? locale : Vue.i18n.locale();
        return new Date(val).toLocaleDateString(
            currentLocale, 
            {
                weekday: "short",
                month: "long",
                day: "numeric"
            }
        );
    }

    public dateYMD(dateValue: Date | string): string {
        if (!dateValue) {
            return '';
        }
        const date = new Date(dateValue);
        return date.getFullYear() 
          + "-" 
          + (date.getMonth() + 1).toString().padStart(2, "0") 
          + "-" 
          + (date.getDate()).toString().padStart(2, '0'); 
      }
    
      public formatDateTimeWithShortWeekDayAndTime(val): string {
        const date = new Date(val);
        const locale = Vue.i18n.locale();
        const dateStr =  date.toLocaleDateString(
            locale, 
            {
                weekday: "short",
                month: "numeric",
                day: "numeric",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            }
        );
        
        return dateStr;
    }
}

export default DateHelper;
